@if (loadingData) {
  <ebs-spinner [spinnerMessage]="'Quiz loading..'" [faColour]="'#fff'" [boxColour]="'#fff'"
  [boxPadding]="'5px 15px'"></ebs-spinner>
}

@if (!loadingData && !activityItem) {
  <div>
    <i class="fa fa-fw fa-lg fa-exclamation-circle"> </i> {{failedMessage}}
  </div>
}
@if (activityItem.questions && activityItem.questions[0]?.questionType != 'feedback') {
  <div class="pl-2">
    <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineMessage'></ebs-offline-message>
  </div>
}

@if (!loadingData) {
  <div>
    <div #target></div>
    <div class="card-body">
      <div class="row">
        @if (activityItem.quizName) {
          <div class="col-sm-10">
            <p>{{activityItem.quizName}}</p>
          </div>
        }
      </div>
      <!-- I think "x == null" checks for both undefined and null, so the if can be simplified -->
      @if (!activityItem.questions || activityItem.questions === undefined || activityItem.questions.length === 0) {
        <div>
          @if (!isOffline) {
            <ebs-message-simple [iconCssClasses]="'fas fa-exclamation-circle fa-lg'" [textCssClasses]="''"
            [displayMessage]="'This quiz has no questions'"></ebs-message-simple>
          }
        </div>
      }
      @if (activityItem && activityItem.questions && activityItem.questions.length > 0) {
        <div>
          @for (question of activityItem.questions; track question) {
            <div>
              @if (question.questionType == 'feedback') {
                <div class="row is-feedback-question">
                  <div class="col-md-12 its">
                    <h2 class="card-header">{{question.name}}</h2>
                  </div>
                </div>
              }
              @if (question.questionType != 'feedback') {
                <div class="row">
                  <div class="col-md-12">
                    <h3>{{question.name}}</h3>
                  </div>
                </div>
              }
              @if (question.questionType=='essay') {
                <div>
                  <div class="row">
                    <div [innerHtml]="question.text | domSanitizerPipe: 'html'" class="col-md-12"></div>
                  </div>
                  <ebs-essay-question [activityItemId]='activityItem.id' [question]='question'></ebs-essay-question>
                </div>
              }
              @if (question.questionType=='multiple-choice') {
                <div>
                  <div class="row">
                    <div [innerHtml]="question.text | domSanitizerPipe: 'html'" class="col-md-12"></div>
                  </div>
                  <ebs-multiple-choice-question [question]='question' (notify)='markIncomplete()' [showFeedback]='showFeedback'>
                  </ebs-multiple-choice-question>
                  <p></p>
                </div>
              }
              @if (question.questionType=='multiple-select') {
                <div>
                  <div class="row">
                    <div [innerHtml]="question.text | domSanitizerPipe: 'html'" class="col-md-12"></div>
                  </div>
                  <ebs-multiple-answers-question [question]='question' (notify)='markIncomplete()'
                  [showFeedback]='showFeedback'></ebs-multiple-answers-question>
                  <p></p>
                </div>
              }
              @if (question.questionType=='paired') {
                <div>
                  <div class="row">
                    <div [innerHtml]="question.text | domSanitizerPipe: 'html'" class="col-md-12"></div>
                  </div>
                  <ebs-match-the-pairs-question (notify)='markIncomplete()' [question]='question' [showFeedback]='showFeedback'>
                  </ebs-match-the-pairs-question>
                  <p></p>
                </div>
              }
              @if (question.questionType=='numerical') {
                <div>
                  <div class="row">
                    <div [innerHtml]="question.text | domSanitizerPipe: 'html'" class="col-md-12"></div>
                  </div>
                  <ebs-numerical-question (notify)='markIncomplete()' [question]='question' [showFeedback]='showFeedback'>
                  </ebs-numerical-question>
                  <p></p>
                </div>
              }
              @if (question.questionType=='feedback') {
                <div>
                  <ebs-feedback-question [activityItemId]='activityItem.id' [question]='question'></ebs-feedback-question>
                  <p></p>
                </div>
              }
            </div>
          }
        </div>
      }
      <p></p>
      <div #scoretarget></div>
      @if (activityItem && activityItem.questions && activityItem.questions[0].questionType != 'feedback'
        && activityItem.questions[0].questionType != 'essay') {
        <hr>
        }
        @if (activityItem && activityItem.questions && (activityItem.questions.length > 1 || activityItem.questions[0].questionType === 'feedback')) {
          <div>
            <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineMessage'></ebs-offline-message>
          </div>
        }
        @if (!isOffline) {
          <div>
            <div class="row">
              <div class="col-12">
                @if (callFailed) {
                  <ebs-notification-multiple [notifications]="notifications"></ebs-notification-multiple>
                }
              </div>
            </div>
            @if (activityItem && activityItem.questions && activityItem.questions[0].questionType != 'essay' && activityItem.questions[0].questionType!='feedback') {
              <div class="d-flex justify-content-between align-items-center">
                <span class="text-info">
                  @if (showFeedback) {
                    <div [@pulse]="showFeedback" style="font-size: 130%">You scored {{totalScore}} out of
                    {{totalPointsAvailable}} points</div>
                    } <br>
                    @if (showFeedback) {
                      <span><a style="cursor:pointer;"
                        (click)="scrollToAnchor(target)"><strong>Review answers</strong></a></span>
                      }
                    </span>
                    <button (click)="restart(target)" [hidden]="!showFeedback" class="btn btn-primary">Take the test again</button>
                  </div>
                }
                <!-- <div *ngIf="activityItem && activityItem.questions && activityItem.questions.length > 1 && activityItem.questions[0].questionType != 'feedback' && activityItem.questions[0].questionType != 'essay'" -->
                @if (activityItem && activityItem.questions && activityItem.questions[0].questionType != 'essay' > 1 && activityItem.questions[0].questionType != 'feedback' && activityItem.questions[0].questionType != 'essay') {
                  <div
                    class="d-flex justify-content-between align-items-center">
                    <span class="text-warning">
                      @if (!showFeedback && !isComplete) {
                        <span [ngClass]="{'no-print': true}">One or more questions are incomplete</span>
                        }<br>
                      </span>
                      <!-- <div #scoretarget></div> -->
                      <button (click)="submit(scoretarget)" [hidden]="showFeedback" class="btn btn-primary">Submit answers</button>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }